import React, { useState } from 'react';

const LeaveRequests = ({ userRole, userId }) => {
  const [requests, setRequests] = useState([
    { id: 1, name: 'John Doe', designation: 'Software Developer', manager: 'Harsh Verma', reportingTo: 'Harsh Verma', type: 'Sick Leave', from: '2024-01-20', to: '2024-01-22', reason: 'Fever', status: 'pending' },
    { id: 2, name: 'Jane Smith', designation: 'HR Executive', manager: 'Sanjiv Singh', reportingTo: 'Sanjiv Singh', type: 'Casual Leave', from: '2024-01-25', to: '2024-01-26', reason: 'Personal work', status: 'approved' },
    { id: 3, name: 'Saurav Kumar', designation: 'Digital Marketing', manager: 'Harsh Verma', reportingTo: 'Harsh Verma', type: 'Paid Leave', from: '2024-02-01', to: '2024-02-02', reason: 'going to bihar ', status: 'pending' },
  ]);

  const [showApplyModal, setShowApplyModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [formData, setFormData] = useState({
    leaveType: '',
    fromDate: '',
    toDate: '',
    reason: '',
    additionalNotes: ''
  });

  // Get current logged in user
  const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
  
  // Get employee details based on role
  const getEmployeeDetails = () => {
    const employeeData = {
      name: currentUser.name || 'Current User',
      designation: getDesignationByRole(userRole),
      manager: getManagerByRole(userRole),
      reportingTo: getReportingToByRole(userRole),
      employeeId: currentUser.id || 'EMP001'
    };
    return employeeData;
  };

  const getDesignationByRole = (role) => {
    switch(role) {
      case 'superadmin': return 'Super Administrator';
      case 'admin': return 'System Administrator';
      case 'hr': return 'HR Manager';
      case 'manager': return 'Department Manager';
      case 'employee': return 'Software Developer';
      default: return 'Employee';
    }
  };

  const getManagerByRole = (role) => {
    switch(role) {
      case 'superadmin': return 'Board of Directors';
      case 'admin': return 'Super Admin';
      case 'hr': return 'Sanjiv Singh (HR Head)';
      case 'manager': return 'Senior Management';
      case 'employee': return 'Harsh Verma (Project Manager)';
      default: return 'HR Department';
    }
  };

  const getReportingToByRole = (role) => {
    switch(role) {
      case 'superadmin': return 'Board of Directors';
      case 'admin': return 'Super Admin';
      case 'hr': return 'CEO Office';
      case 'manager': return 'VP of Operations';
      case 'employee': return 'Harsh Verma';
      default: return 'HR Department';
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleReasonChange = (e) => {
    const value = e.target.value;
    if (value.length <= 500) {
      setFormData(prev => ({ ...prev, reason: value }));
    }
  };

  const handleAdditionalNotesChange = (e) => {
    const value = e.target.value;
    if (value.length <= 500) {
      setFormData(prev => ({ ...prev, additionalNotes: value }));
    }
  };

  const handleSubmitLeave = (e) => {
    e.preventDefault();
    
    // Validate dates
    if (formData.fromDate && formData.toDate && formData.toDate < formData.fromDate) {
      alert('End date cannot be earlier than start date');
      return;
    }
    
    // Validate reason length
    if (formData.reason.length > 500) {
      alert('Reason cannot exceed 500 characters');
      return;
    }
    
    // Validate additional notes length
    if (formData.additionalNotes.length > 500) {
      alert('Additional notes cannot exceed 500 characters');
      return;
    }
    
    const employeeDetails = getEmployeeDetails();
    const newRequest = {
      id: requests.length + 1,
      name: employeeDetails.name,
      designation: employeeDetails.designation,
      manager: employeeDetails.manager,
      reportingTo: employeeDetails.reportingTo,
      type: formData.leaveType,
      from: formData.fromDate,
      to: formData.toDate,
      reason: formData.reason,
      additionalNotes: formData.additionalNotes,
      status: 'pending',
      appliedOn: new Date().toISOString().split('T')[0]
    };
    
    setRequests([newRequest, ...requests]);
    alert('Leave request submitted successfully!');
    setShowApplyModal(false);
    resetFormData();
  };

  const handleEditSubmit = (e) => {
    e.preventDefault();
    
    // Validate dates
    if (formData.fromDate && formData.toDate && formData.toDate < formData.fromDate) {
      alert('End date cannot be earlier than start date');
      return;
    }
    
    // Validate reason length
    if (formData.reason.length > 500) {
      alert('Reason cannot exceed 500 characters');
      return;
    }
    
    setRequests(requests.map(req => 
      req.id === selectedRequest.id 
        ? { 
            ...req, 
            type: formData.leaveType,
            from: formData.fromDate,
            to: formData.toDate,
            reason: formData.reason,
            additionalNotes: formData.additionalNotes
          } 
        : req
    ));
    
    alert('Leave request updated successfully!');
    setShowEditModal(false);
    setSelectedRequest(null);
    resetFormData();
  };

  const handleView = (request) => {
    setSelectedRequest(request);
    setShowViewModal(true);
  };

  const handleEdit = (request) => {
    setSelectedRequest(request);
    setFormData({
      leaveType: request.type,
      fromDate: request.from,
      toDate: request.to,
      reason: request.reason || '',
      additionalNotes: request.additionalNotes || ''
    });
    setShowEditModal(true);
  };

  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this leave request? This action cannot be undone.')) {
      setRequests(requests.filter(req => req.id !== id));
      alert('Leave request deleted successfully!');
    }
  };

  const resetFormData = () => {
    setFormData({
      leaveType: '',
      fromDate: '',
      toDate: '',
      reason: '',
      additionalNotes: ''
    });
  };

  const handleApprove = (id) => {
    setRequests(requests.map(req => req.id === id ? { ...req, status: 'approved' } : req));
    alert('Leave request approved!');
  };

  const handleReject = (id) => {
    setRequests(requests.map(req => req.id === id ? { ...req, status: 'rejected' } : req));
    alert('Leave request rejected!');
  };

  const canApprove = ['manager', 'hr', 'admin', 'superadmin'].includes(userRole);
  const canEditDelete = ['employee', 'manager', 'hr', 'admin', 'superadmin'].includes(userRole);
  const employeeDetails = getEmployeeDetails();

  // Calculate days between two dates
  const calculateDays = (from, to) => {
    return Math.ceil((new Date(to) - new Date(from)) / (1000 * 60 * 60 * 24)) + 1;
  };

  return (
    <>
      <div>
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-2xl font-bold text-gray-800">Leave Requests</h1>
            <p className="text-sm text-gray-500 mt-1">Manage and track employee leave applications</p>
          </div>
          <button 
            onClick={() => setShowApplyModal(true)}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition flex items-center gap-2"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            Apply Leave
          </button>
        </div>
        
        {/* Leave Statistics Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-4 gap-4 mb-6">
          <div className="bg-white rounded-xl border border-gray-200 p-4">
            <p className="text-sm text-gray-500">Total Leaves</p>
            <p className="text-2xl font-bold text-gray-800">12</p>
          </div>
          <div className="bg-white rounded-xl border border-gray-200 p-4">
            <p className="text-sm text-gray-500">Used Leaves</p>
            <p className="text-2xl font-bold text-yellow-600">5</p>
          </div>
          <div className="bg-white rounded-xl border border-gray-200 p-4">
            <p className="text-sm text-gray-500">Remaining Leaves</p>
            <p className="text-2xl font-bold text-green-600">7</p>
          </div>
          <div className="bg-white rounded-xl border border-gray-200 p-4">
            <p className="text-sm text-gray-500">Pending Requests</p>
            <p className="text-2xl font-bold text-orange-600">{requests.filter(r => r.status === 'pending').length}</p>
          </div>
        </div>
      
        <div className="bg-white rounded-xl shadow-sm overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[1200px]">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Employee</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Designation</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Reporting To</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Leave Type</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Duration</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Reason</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {requests.map(req => (
                  <tr key={req.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4">
                      <div>
                        <p className="text-sm font-medium text-gray-900">{req.name}</p>
                        <p className="text-xs text-gray-500">ID: EMP00{req.id}</p>
                      </div>
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-600">{req.designation}</td>
                    <td className="px-6 py-4 text-sm text-gray-600">{req.reportingTo}</td>
                    <td className="px-6 py-4 text-sm text-gray-600">{req.type}</td>
                    <td className="px-6 py-4 text-sm text-gray-600">
                      {req.from} to {req.to}
                      <p className="text-xs text-gray-400">{calculateDays(req.from, req.to)} days</p>
                    </td>
                    <td className="px-6 py-4">
                      <div className="max-w-xs h-20 overflow-y-auto text-sm text-gray-600 pr-2 custom-scrollbar">
                        <p>{req.reason}</p>
                        {req.additionalNotes && (
                          <p className="text-xs text-gray-400 mt-1 border-t pt-1">Note: {req.additionalNotes}</p>
                        )}
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <span className={`text-xs px-2 py-1 rounded-full ${
                        req.status === 'approved' ? 'bg-green-100 text-green-700' :
                        req.status === 'rejected' ? 'bg-red-100 text-red-700' : 'bg-yellow-100 text-yellow-700'
                      }`}>
                        {req.status.toUpperCase()}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-2">
                        {/* View Button */}
                        <button
                          onClick={() => handleView(req)}
                          className="text-blue-600 hover:text-blue-800 p-1 transition"
                          title="View Details"
                        >
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                          </svg>
                        </button>
                        
                        {/* Edit Button - Only for pending requests or employees own requests */}
                        {canEditDelete && req.status === 'pending' && (
                          <button
                            onClick={() => handleEdit(req)}
                            className="text-green-600 hover:text-green-800 p-1 transition"
                            title="Edit Request"
                          >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                          </button>
                        )}
                        
                        {/* Delete Button */}
                        {canEditDelete && req.status === 'pending' && (
                          <button
                            onClick={() => handleDelete(req.id)}
                            className="text-red-600 hover:text-red-800 p-1 transition"
                            title="Delete Request"
                          >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                          </button>
                        )}
                        
                        {/* Approve/Reject buttons for managers */}
                        {canApprove && req.status === 'pending' && (
                          <div className="flex items-center gap-1 ml-1 pl-1 border-l border-gray-200">
                            <button
                              onClick={() => handleApprove(req.id)}
                              className="text-green-600 hover:text-green-800 text-xs font-medium px-2 py-1 rounded hover:bg-green-50"
                              title="Approve"
                            >
                              Approve
                            </button>
                            <button
                              onClick={() => handleReject(req.id)}
                              className="text-red-600 hover:text-red-800 text-xs font-medium px-2 py-1 rounded hover:bg-red-50"
                              title="Reject"
                            >
                              Reject
                            </button>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* View Leave Modal */}
      {showViewModal && selectedRequest && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
          <div className="bg-white rounded-xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center">
              <div>
                <h2 className="text-xl font-semibold text-gray-800">Leave Request Details</h2>
                <p className="text-sm text-gray-500">View complete leave application information</p>
              </div>
              <button onClick={() => { setShowViewModal(false); setSelectedRequest(null); }} className="text-gray-400 hover:text-gray-600">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            <div className="p-6">
              {/* Status Banner */}
              <div className={`mb-6 p-3 rounded-lg ${
                selectedRequest.status === 'approved' ? 'bg-green-50 border border-green-200' :
                selectedRequest.status === 'rejected' ? 'bg-red-50 border border-red-200' : 'bg-yellow-50 border border-yellow-200'
              }`}>
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium">Request Status</span>
                  <span className={`text-xs px-2 py-1 rounded-full ${
                    selectedRequest.status === 'approved' ? 'bg-green-100 text-green-700' :
                    selectedRequest.status === 'rejected' ? 'bg-red-100 text-red-700' : 'bg-yellow-100 text-yellow-700'
                  }`}>
                    {selectedRequest.status.toUpperCase()}
                  </span>
                </div>
              </div>

              {/* Employee Information */}
              <div className="bg-gray-50 rounded-lg p-4 mb-6">
                <h3 className="text-sm font-semibold text-gray-800 mb-3">Employee Information</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="text-xs text-gray-500">Employee Name</label>
                    <p className="text-sm font-medium text-gray-800">{selectedRequest.name}</p>
                  </div>
                  <div>
                    <label className="text-xs text-gray-500">Employee ID</label>
                    <p className="text-sm font-medium text-gray-800">EMP00{selectedRequest.id}</p>
                  </div>
                  <div>
                    <label className="text-xs text-gray-500">Designation</label>
                    <p className="text-sm font-medium text-gray-800">{selectedRequest.designation}</p>
                  </div>
                  <div>
                    <label className="text-xs text-gray-500">Reporting Manager</label>
                    <p className="text-sm font-medium text-gray-800">{selectedRequest.manager}</p>
                  </div>
                  <div>
                    <label className="text-xs text-gray-500">Reporting To</label>
                    <p className="text-sm font-medium text-gray-800">{selectedRequest.reportingTo}</p>
                  </div>
                  <div>
                    <label className="text-xs text-gray-500">Applied On</label>
                    <p className="text-sm font-medium text-gray-800">{selectedRequest.appliedOn || 'N/A'}</p>
                  </div>
                </div>
              </div>

              {/* Leave Details */}
              <div className="bg-gray-50 rounded-lg p-4 mb-6">
                <h3 className="text-sm font-semibold text-gray-800 mb-3">Leave Details</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="text-xs text-gray-500">Leave Type</label>
                    <p className="text-sm font-medium text-gray-800">{selectedRequest.type}</p>
                  </div>
                  <div>
                    <label className="text-xs text-gray-500">Duration</label>
                    <p className="text-sm font-medium text-gray-800">
                      {selectedRequest.from} to {selectedRequest.to}
                    </p>
                    <p className="text-xs text-gray-400">{calculateDays(selectedRequest.from, selectedRequest.to)} days total</p>
                  </div>
                </div>
              </div>

              {/* Reason */}
              <div className="bg-gray-50 rounded-lg p-4 mb-6">
                <h3 className="text-sm font-semibold text-gray-800 mb-3">Reason for Leave</h3>
                <div className="bg-white rounded-lg p-3 border border-gray-200">
                  <p className="text-sm text-gray-700 whitespace-pre-wrap">{selectedRequest.reason}</p>
                </div>
              </div>

              {/* Additional Notes */}
              {selectedRequest.additionalNotes && (
                <div className="bg-gray-50 rounded-lg p-4 mb-6">
                  <h3 className="text-sm font-semibold text-gray-800 mb-3">Additional Notes</h3>
                  <div className="bg-white rounded-lg p-3 border border-gray-200">
                    <p className="text-sm text-gray-700 whitespace-pre-wrap">{selectedRequest.additionalNotes}</p>
                  </div>
                </div>
              )}

              <div className="flex gap-3 justify-end pt-4 border-t">
                <button
                  onClick={() => { setShowViewModal(false); setSelectedRequest(null); }}
                  className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition"
                >
                  Close
                </button>
                {selectedRequest.status === 'pending' && (
                  <button
                    onClick={() => {
                      setShowViewModal(false);
                      handleEdit(selectedRequest);
                    }}
                    className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition"
                  >
                    Edit Request
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Edit Leave Modal */}
      {showEditModal && selectedRequest && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
          <div className="bg-white rounded-xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center">
              <div>
                <h2 className="text-xl font-semibold text-gray-800">Edit Leave Request</h2>
                <p className="text-sm text-gray-500">Modify your leave application details</p>
              </div>
              <button onClick={() => { setShowEditModal(false); setSelectedRequest(null); resetFormData(); }} className="text-gray-400 hover:text-gray-600">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            <form onSubmit={handleEditSubmit} className="p-6">
              {/* Employee Information Section (Read-only) */}
              <div className="bg-gray-50 rounded-lg p-4 mb-6">
                <h3 className="text-sm font-semibold text-gray-800 mb-3">Employee Information</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="text-xs text-gray-500">Employee Name</label>
                    <p className="text-sm font-medium text-gray-800">{selectedRequest.name}</p>
                  </div>
                  <div>
                    <label className="text-xs text-gray-500">Designation</label>
                    <p className="text-sm font-medium text-gray-800">{selectedRequest.designation}</p>
                  </div>
                  <div>
                    <label className="text-xs text-gray-500">Reporting Manager</label>
                    <p className="text-sm font-medium text-gray-800">{selectedRequest.manager}</p>
                  </div>
                  <div>
                    <label className="text-xs text-gray-500">Reporting To</label>
                    <p className="text-sm font-medium text-gray-800">{selectedRequest.reportingTo}</p>
                  </div>
                </div>
              </div>

              {/* Leave Details Section */}
              <h3 className="text-sm font-semibold text-gray-800 mb-3">Leave Details</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Leave Type *</label>
                  <select
                    name="leaveType"
                    required
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={formData.leaveType}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Leave Type</option>
                    <option value="Sick Leave">Sick Leave</option>
                    <option value="Casual Leave">Casual Leave</option>
                    <option value="Annual Leave">Annual Leave</option>
                    <option value="Emergency Leave">Emergency Leave</option>
                    <option value="Maternity Leave">Maternity Leave</option>
                    <option value="Paternity Leave">Paternity Leave</option>
                    <option value="Bereavement Leave">Bereavement Leave</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">From Date *</label>
                  <input
                    type="date"
                    name="fromDate"
                    required
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={formData.fromDate}
                    onChange={handleInputChange}
                    min="2024-01-01"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">To Date *</label>
                  <input
                    type="date"
                    name="toDate"
                    required
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={formData.toDate}
                    onChange={handleInputChange}
                    min={formData.fromDate || "2024-01-01"}
                  />
                  {formData.fromDate && formData.toDate && formData.toDate < formData.fromDate && (
                    <p className="text-red-500 text-xs mt-1">End date cannot be earlier than start date</p>
                  )}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Total Days</label>
                  <input
                    type="text"
                    readOnly
                    className="w-full px-3 py-2 border border-gray-200 rounded-lg bg-gray-50 text-gray-600"
                    value={formData.fromDate && formData.toDate && formData.toDate >= formData.fromDate ? 
                      `${calculateDays(formData.fromDate, formData.toDate)} days` : 
                      'Select valid dates'}
                  />
                </div>
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Reason for Leave *</label>
                <textarea
                  name="reason"
                  rows={3}
                  required
                  placeholder="Please provide detailed reason for your leave..."
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={formData.reason}
                  onChange={handleReasonChange}
                  maxLength={500}
                />
                <div className="text-right text-xs text-gray-400 mt-1">{formData.reason.length}/500 characters</div>
              </div>

              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-1">Additional Notes</label>
                <textarea
                  name="additionalNotes"
                  rows={2}
                  placeholder="Any additional information..."
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={formData.additionalNotes}
                  onChange={handleAdditionalNotesChange}
                  maxLength={500}
                />
                <div className="text-right text-xs text-gray-400 mt-1">{formData.additionalNotes.length}/500 characters</div>
              </div>

              <div className="flex gap-3 justify-end pt-4 border-t">
                <button
                  type="button"
                  onClick={() => { setShowEditModal(false); setSelectedRequest(null); resetFormData(); }}
                  className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition"
                >
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Apply Leave Modal */}
      {showApplyModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
          <div className="bg-white rounded-xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center">
              <div>
                <h2 className="text-xl font-semibold text-gray-800">Apply for Leave</h2>
                <p className="text-sm text-gray-500">Fill in the details to submit your leave request</p>
              </div>
              <button onClick={() => setShowApplyModal(false)} className="text-gray-400 hover:text-gray-600">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            <form onSubmit={handleSubmitLeave} className="p-6">
              {/* Employee Information Section */}
              <div className="bg-gray-50 rounded-lg p-4 mb-6">
                <h3 className="text-sm font-semibold text-gray-800 mb-3">Employee Information</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="text-xs text-gray-500">Employee Name</label>
                    <p className="text-sm font-medium text-gray-800">{employeeDetails.name}</p>
                  </div>
                  <div>
                    <label className="text-xs text-gray-500">Designation</label>
                    <p className="text-sm font-medium text-gray-800">{employeeDetails.designation}</p>
                  </div>
                  <div>
                    <label className="text-xs text-gray-500">Reporting Manager</label>
                    <p className="text-sm font-medium text-gray-800">{employeeDetails.manager}</p>
                  </div>
                  <div>
                    <label className="text-xs text-gray-500">Reporting To</label>
                    <p className="text-sm font-medium text-gray-800">{employeeDetails.reportingTo}</p>
                  </div>
                </div>
              </div>

              {/* Leave Details Section */}
              <h3 className="text-sm font-semibold text-gray-800 mb-3">Leave Details</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Leave Type *</label>
                  <select
                    name="leaveType"
                    required
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={formData.leaveType}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Leave Type</option>
                    <option value="Sick Leave">Sick Leave</option>
                    <option value="Casual Leave">Casual Leave</option>
                    <option value="Annual Leave">Annual Leave</option>
                    <option value="Emergency Leave">Emergency Leave</option>
                    <option value="Maternity Leave">Maternity Leave</option>
                    <option value="Paternity Leave">Paternity Leave</option>
                    <option value="Bereavement Leave">Bereavement Leave</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">From Date *</label>
                  <input
                    type="date"
                    name="fromDate"
                    required
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={formData.fromDate}
                    onChange={handleInputChange}
                    min="2024-01-01"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">To Date *</label>
                  <input
                    type="date"
                    name="toDate"
                    required
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={formData.toDate}
                    onChange={handleInputChange}
                    min={formData.fromDate || "2024-01-01"}
                  />
                  {formData.fromDate && formData.toDate && formData.toDate < formData.fromDate && (
                    <p className="text-red-500 text-xs mt-1">End date cannot be earlier than start date</p>
                  )}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Total Days</label>
                  <input
                    type="text"
                    readOnly
                    className="w-full px-3 py-2 border border-gray-200 rounded-lg bg-gray-50 text-gray-600"
                    value={formData.fromDate && formData.toDate && formData.toDate >= formData.fromDate ? 
                      `${calculateDays(formData.fromDate, formData.toDate)} days` : 
                      'Select valid dates'}
                  />
                </div>
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Reason for Leave *</label>
                <textarea
                  name="reason"
                  rows={3}
                  required
                  placeholder="Please provide detailed reason for your leave..."
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={formData.reason}
                  onChange={handleReasonChange}
                  maxLength={500}
                />
                <div className="text-right text-xs text-gray-400 mt-1">{formData.reason.length}/500 characters</div>
              </div>

              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-1">Additional Notes</label>
                <textarea
                  name="additionalNotes"
                  rows={2}
                  placeholder="Any additional information..."
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={formData.additionalNotes}
                  onChange={handleAdditionalNotesChange}
                  maxLength={500}
                />
                <div className="text-right text-xs text-gray-400 mt-1">{formData.additionalNotes.length}/500 characters</div>
              </div>

              <div className="flex gap-3 justify-end pt-4 border-t">
                <button
                  type="button"
                  onClick={() => setShowApplyModal(false)}
                  className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
                >
                  Submit Request
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <style>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 4px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 4px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #c1c1c1;
          border-radius: 4px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #a8a8a8;
        }
      `}</style>
    </>
  );
};

export default LeaveRequests;